import(/* webpackMode: "eager" */ "/vercel/path0/apps/app/src/app/global-error.tsx");
